"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 19h2v2h-2zM13 19h2v2h-2zM1 19c0 1.1.9 2 2 2h8v-6H1v4zM9 3h2v2H9zM5 3h2v2H5zM17 3h2v2h-2zM1 11h2v2H1zM1 7h2v2H1zM3 3C2 3 1 4 1 5h2V3zM13 3h2v2h-2zM21 21c1 0 2-1 2-2h-2v2zM21 11h2v2h-2zM21 3v2h2c0-1-1-2-2-2zM21 15h2v2h-2zM21 7h2v2h-2z"
}))), 'PhotoSizeSelectSmallTwoTone');

exports.default = _default;